
<template>
  <div class="global-toast-container">
    <transition-group name="toast" tag="div">
      <div
        v-for="toast in toasts"
        :key="toast.id"
        class="global-toast"
        :class="'toast-' + toast.type"
        role="status"
      >
        <!-- ICON -->
        <div class="toast-icon">
          <span v-if="toast.type === 'success'">✓</span>
          <span v-else-if="toast.type === 'error'">✕</span>
          <span v-else-if="toast.type === 'warning'">!</span>
          <span v-else>i</span>
        </div>

        <!-- CONTENT -->
        <div class="toast-content">
          <strong>{{ toast.title }}</strong>
          <p v-if="toast.message">{{ toast.message }}</p>
        </div>

        <!-- CLOSE -->
        <button
          type="button"
          class="toast-close"
          :aria-label="'Fermer ' + toast.title"
          @click="removeToast(toast.id)"
        >
          ✕
        </button>

        <!-- PROGRESS BAR -->
        <div
          class="toast-progress"
          :style="{ animationDuration: toast.duration + 'ms' }"
        ></div>
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: "GlobalToast",

  computed: {
    toasts() {
      return this.$store.state.toast.items;
    },
  },

  methods: {
    removeToast(id) {
      this.$store.dispatch("toast/remove", id);
    },
  },
};
</script>

<style scoped>
.global-toast-container {
  position: fixed;
  top: 90px;
  right: 22px;
  z-index: 99999;
  width: 390px;
  max-width: calc(100vw - 30px);
  pointer-events: none;
}

.global-toast {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 13px;
  margin-bottom: 12px;
  padding: 17px 18px 20px;
  border: 1px solid #e6ebef;
  border-left: 4px solid #ff7900;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 12px 40px rgba(20, 28, 38, 0.14);
  overflow: hidden;
  pointer-events: auto;
}

.toast-icon {
  display: grid;
  place-items: center;
  width: 38px;
  height: 38px;
  flex-shrink: 0;
  border-radius: 50%;
  font-size: 20px;
  font-weight: 800;
}

.toast-success {
  border-left-color: #20a36b;
}

.toast-success .toast-icon {
  background: #e7f8ef;
  color: #20a36b;
}

.toast-error {
  border-left-color: #df4c4c;
}

.toast-error .toast-icon {
  background: #ffeded;
  color: #df4c4c;
}

.toast-warning {
  border-left-color: #ff7900;
}

.toast-warning .toast-icon {
  background: #fff0e3;
  color: #ff7900;
}

.toast-info {
  border-left-color: #4388d0;
}

.toast-info .toast-icon {
  background: #eaf3ff;
  color: #4388d0;
}

.toast-content {
  flex: 1;
  min-width: 0;
}

.toast-content strong {
  display: block;
  color: #20272e;
  font-size: 13px;
  font-weight: 800;
}

.toast-content p {
  margin: 5px 0 0;
  color: #87939e;
  font-size: 11px;
  line-height: 1.6;
  overflow-wrap: anywhere;
}

.toast-close {
  flex-shrink: 0;
  padding: 2px;
  border: 0;
  background: transparent;
  color: #929ca6;
  font-size: 15px;
  cursor: pointer;
}

.toast-progress {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 3px;
  background: #ff7900;
  transform-origin: left;
  animation: toast-progress linear forwards;
}

.toast-success .toast-progress {
  background: #20a36b;
}

.toast-error .toast-progress {
  background: #df4c4c;
}

.toast-info .toast-progress {
  background: #4388d0;
}

@keyframes toast-progress {
  from { transform: scaleX(1); }
  to { transform: scaleX(0); }
}

.toast-enter-active,
.toast-leave-active,
.toast-move {
  transition: all 0.3s ease;
}

.toast-enter,
.toast-leave-to {
  opacity: 0;
  transform: translateX(35px);
}

@media (max-width: 600px) {
  .global-toast-container {
    top: 75px;
    right: 15px;
    left: 15px;
    width: auto;
  }

  .global-toast {
    padding: 14px 15px 18px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .toast-enter-active,
  .toast-leave-active,
  .toast-move {
    transition: none;
  }

  .toast-progress {
    animation: none;
  }
}
</style>
